import { defineMessages } from 'react-intl';

export default defineMessages({
    
    welcome: {
        id: 'portal.views.home-page-layout.Welcome',
        defaultMessage: 'Welcome Inception'
    },
    likeToday: {
        id: 'portal.views.home-page-layout.What would you like to do today?',
        defaultMessage: 'What would you like to do today?'
    },
    fileClaim: {
        id: 'portal.views.home-page-layout.FileClaim',
        defaultMessage: 'File a Claim'
    },
    fileClaimWC: {
        id: 'ext.portal.views.home-page-layout.FileWCClaim',
        defaultMessage: 'File a WC Claim'
    },
    reportPayroll: {
        id: 'portal.views.home-page-layout.Report Payroll',
        defaultMessage: 'Report Payroll'
    },
    certificateInsurance: {
        id: 'portal.views.home-page-layout.Certificates of Insurance',
        defaultMessage: 'Certificates of Insurance'
    },
    viewAccount: {
        id: 'portal.views.home-page-layout.View Account',
        defaultMessage: 'View Account'
    },
    myProfile: {
        id: 'portal.views.home-page-layout.My Profile',
        defaultMessage: 'My Profile'
    },
    makeaPayment: {
        id: 'portal.views.home-page-layout.Make a Payment',
        defaultMessage: 'Make a Payment'
    },
    
});